import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PeligroDTO } from '../../types/Peligro';

interface RiesgosState {
  peligrosPersonales: PeligroDTO[];
  loadingPeligros: boolean;
  errorPeligros: string | null;
}

const initialState: RiesgosState = {
  peligrosPersonales: [],
  loadingPeligros: false,
  errorPeligros: null,
};

const RiesgosSlice = createSlice({
  name: 'riesgos',
  initialState,
  reducers: {
    loadPeligrosPersonales: (
      state,
      action: PayloadAction<PeligroDTO[]>
    ): void => {
      state.peligrosPersonales = action.payload;
      state.errorPeligros = null;
    },
    setLoadingPeligros: (
      state,
      action: PayloadAction<boolean>
    ): void => {
      state.loadingPeligros = action.payload;
    },
    setErrorPeligros: (
      state,
      action: PayloadAction<string | null>
    ): void => {
      state.errorPeligros = action.payload;
    },
  },
});

export const {
  loadPeligrosPersonales,
  setLoadingPeligros,
  setErrorPeligros,
} = RiesgosSlice.actions;

export default RiesgosSlice.reducer;
